import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: 'cs-card-title',
  templateUrl: 'cs-card-title.html',
  host: { 'class': 'card-title' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsCardTitleComponent {
}